import React from "react";
import { Check, Minus } from "lucide-react";

/**
 * Checkbox
 * @param {boolean}  checked
 * @param {function} onChange      - recibe el nuevo valor boolean
 * @param {string}   label
 * @param {"primary"|"secondary"|"accent"|"success"|"warning"|"error"} color
 * @param {boolean}  indeterminate - estado intermedio (muestra guión)
 * @param {boolean}  disabled
 */
export default function Checkbox({
    checked = false,
    onChange,
    label,
    color = "primary",
    indeterminate = false,
    disabled = false,
}) {
    const colorMap = {
        primary:   { bg: "bg-primary",   border: "border-primary",   text: "text-primary-content" },
        secondary: { bg: "bg-secondary", border: "border-secondary", text: "text-secondary-content" },
        accent:    { bg: "bg-accent",    border: "border-accent",    text: "text-accent-content" },
        success:   { bg: "bg-success",   border: "border-success",   text: "text-success-content" },
        warning:   { bg: "bg-warning",   border: "border-warning",   text: "text-warning-content" },
        error:     { bg: "bg-error",     border: "border-error",     text: "text-error-content" },
    };

    const c = colorMap[color] ?? colorMap.primary;
    const active = checked || indeterminate;

    return (
        <label
            className={`inline-flex items-center gap-2 select-none ${disabled ? "opacity-40 cursor-not-allowed" : "cursor-pointer"}`}
        >
            <button
                type="button"
                role="checkbox"
                aria-checked={indeterminate ? "mixed" : checked}
                disabled={disabled}
                onClick={() => !disabled && onChange?.(!checked)}
                className={`
                    w-5 h-5 rounded flex items-center justify-center border-2 shrink-0
                    transition-colors duration-150 outline-none
                    focus-visible:ring-2 focus-visible:ring-offset-1 focus-visible:ring-primary
                    ${active
                        ? `${c.bg} ${c.border}`
                        : "bg-transparent border-gray-400 dark:border-gray-500"
                    }
                `}
            >
                {indeterminate
                    ? <Minus size={11} className={c.text} strokeWidth={3} />
                    : checked
                        ? <Check size={11} className={c.text} strokeWidth={3} />
                        : null
                }
            </button>
            {label && (
                <span className="text-sm dark:text-gray-200 text-gray-700 leading-none">{label}</span>
            )}
        </label>
    );
}
